// ============================================================================
// FITCLUTCH (funil web) — DESPACHANTE DE TEXTOS FIXOS DE INTERFACE
// ============================================================================
// Mesmo padrão do fitclutch-mobile/src/i18n/strings.js: detecta o idioma do
// navegador uma vez e carrega o dicionário certo. Qualquer componente pode
// chamar:
//   import { t } from '../../i18n/strings.js';
//   <h1>{t('ageSelect.title')}</h1>
//   <p>{t('ageSelect.cta', { idade: 25 })}</p>
// Chaves com {variavel} são substituídas automaticamente pelo segundo
// argumento (mesmo fillTemplate usado em outras partes do app).
//
// IMPORTANTE: o mercado BRASIL (pt) tem um checkout/oferta diferente dos
// outros 7 mercados (ver fitclutch-app/pesquisa-concorrentes.md — decisão
// de 19/09/2026: BR é assinatura semanal, os outros 7 são mensal/anual).
// Esse dicionário só cuida do TEXTO da interface; a lógica de qual oferta
// mostrar por mercado vive em quizConfig.js / Paywall.jsx.
// ============================================================================

import { getBrowserLanguage, getForcedLanguageFromUrl, DEFAULT_LANGUAGE } from './detectLanguage.js';
import en from './strings.en.js';
import pt from './strings.pt.js';
import es from './strings.es.js';
import fr from './strings.fr.js';
import it from './strings.it.js';
import de from './strings.de.js';
import no from './strings.no.js';
import hi from './strings.hi.js';

const DICTS = { en, pt, es, fr, it, de, no, hi };

const lang = getForcedLanguageFromUrl() ?? getBrowserLanguage() ?? DEFAULT_LANGUAGE;
const activeDict = DICTS[lang] ?? DICTS.en;

export function t(key, vars) {
  const template = activeDict[key] ?? DICTS.en[key] ?? key;
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? `{${k}}`));
}

export const currentLanguage = lang;
